module.exports = __webpack_public_path__ + "static/media/header_fondo.1cbf115f.png";